export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5420.04e7821b.jpg";